























import { Component, Prop, Vue } from "vue-property-decorator";
import TweetPolitik from "@/components/projects/TweetPolitik.vue";

@Component({
  components: {
    tweetPolitik: TweetPolitik
  },
  props: {
    parentRefs:Object
  }
})
export default class Portfolio extends Vue {
  parentRefs:any

  data() {
    return {};
  }

  mounted() {
    console.log("Portfolio");
  }

  modalOpen(modal:string) {
    switch(modal) {
      case 'tp': {
        this.parentRefs.tp_lottie.asModal();
        break;
      }
    }
  }
}
